import { useMediaQuery } from "react-responsive"

export const useIsMobile = () => {
    return useMediaQuery({ query: "(max-width: 767px)" })
}

export const useIsTablet = () => useMediaQuery({ minWidth: 768, maxWidth: 991 })

